import { createContext, PropsWithChildren, useContext } from 'react';

import { AppStore } from '@/dmdrive/core/stores/AppStore';
import { DriveStore } from '@/dmdrive/drive/stores/DriveStore';

class Store {
  appStore: AppStore;
  driveStore: DriveStore;

  constructor() {
    this.appStore = new AppStore();
    this.driveStore = new DriveStore();
  }
}

export const store = new Store();

const StoreContext = createContext<Store>(store);

export function StoreProvider({ children }: PropsWithChildren<unknown>) {
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}

export function useStore<T extends keyof Store>(key: T): Store[T] {
  const context = useContext(StoreContext);

  if (!context[key]) {
    throw new Error(`No "${key}" in Store!`);
  }

  return context[key];
}

export type { Store };
export default store;
